
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PermissionsSettingsState = {
  permissionsSettings: {},
  permissionsSettingsLoading: false,
  permissionsEnableDetails: false,
}

export const PermissionsSettingsActions = {
  createPermissionsSettings: async ({ commit }, value) => {
    commit('setPermissionsSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'permission',
        value,
      }).
      then(({ data }) => {
        commit('setPermissionsEnableDetails', false)
        commit('setPermissionsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setPermissionsSettingsLoading', false))
  },

  getPermissionsSettings: async ({ commit }) => {
    commit('setPermissionsSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/permission').
      then(({ data }) => {
        commit('setPermissionsEnableDetails', false)
        commit('setPermissionsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setPermissionsSettingsLoading', false))
  },

  updatePermissionsSettings: async ({ getters, commit }, value) => {
    commit('setPermissionsSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.permissionsSettingsId}`, {
        name: 'permission',
        value,
      }).
      then(({ data }) => {
        commit('setPermissionsEnableDetails', false)
        commit('setPermissionsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setPermissionsSettingsLoading', false))
  },

  deletePermissionsSettings: async ({ getters, commit }) => {
    commit('setPermissionsSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.permissionsSettingsId}`).
      then(({ data }) => {
        commit('setPermissionsEnableDetails', false)
        commit('setPermissionsSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setPermissionsSettingsLoading', false))
  },
}

export const PermissionsSettingsMutations = {
  setPermissionsSettings: (state, value) => {
    state.permissionsSettings = value
  },

  setPermissionsSettingsLoading: (state, value) => {
    state.permissionsSettingsLoading = value
  },

  setPermissionsEnableDetails: (state, value) => {
    state.permissionsEnableDetails = value
  },
}

export const PermissionsSettingsGetters = {
  permissionsSettingsId: state => state.permissionsSettings.id,
  permissionsSettings: state => state.permissionsSettings,
  permissionsSettingsLoading: state => state.permissionsSettingsLoading,
  permissionsEnableDetails: state => state.permissionsEnableDetails,
  permissionsSettingsValue: state => state.permissionsSettings.value,
}
